import { text } from './textVariants';
import { defaultTitle } from '../Title/titleVariants';

// The variants are actually imported by the theme, but colocating helps finding them more easily.

export default {
  large: {
    ...text,
    fontWeight: 'light',
    fontSize: 'large',
    lineHeight: 'large',
    letterSpacing: 'large',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: 0,
    marginBottom: 3,
  },

  default: {
    ...text,
    marginTop: 0,
    marginBottom: 3,
  },

  /**
   * A paragraph styled like a title.
   * Used for short texts in the event directory, such as the year founded.
   */
  title: defaultTitle,
};
